import submit from '../Services/submit'

export default async (values, dispatch) => {

  await dispatch(submit(values))

}